import { z } from 'zod'
import { oc } from '@orpc/contract'
import { boardItemSchema } from '../../boards/handlers/boards-shared.contract'
import { outgoingFaxMessageId } from './link-outgoing-fax.contract'

/**
 * Edit an existing fax link (PD-1606): correct its note, move it to a different
 * task, or both in one action.
 *
 * One procedure rather than an unlink+link pair from the web, because a two-call
 * move that half-fails loses the record entirely. Here the target is written
 * first, so the worst case leaves the fax linked to both tasks — visible and
 * fixable — instead of to neither.
 */
export const updateOutgoingFaxLink = oc
  .route({ method: 'POST', path: '/v2/fax-tasks/outgoing-links/update' })
  .input(
    z
      .object({
        // The task the link is on now.
        itemId: z.string().min(1),
        messageId: outgoingFaxMessageId,
        // Move the link here. Omitted (or equal to itemId) leaves it in place.
        targetItemId: z.string().min(1).optional(),
        // Replaces the note. An empty string clears it; omitted leaves it as is —
        // which is why this is max-only, with no min length.
        note: z.string().trim().max(500).optional(),
      })
      .refine((v) => v.targetItemId !== undefined || v.note !== undefined, {
        message: 'Nothing to update: provide a new task, a new note, or both',
      }),
  )
  // The item the link now lives on — the target when it moved, so the caller can
  // refresh from one response.
  .output(z.object({ item: boardItemSchema }))
